import {
  getCellKind,
  getRawInputKind,
} from "@/payroll/ai-script/cell-kind-utils";
import { findSheetResponseCell } from "@/payroll/ai-script/spreadsheet-cache";
import {
  AI_SPREADSHEET_VALUE_TYPE,
  type AiSpreadsheetValueType,
  type IAiSpreadsheetCell,
  type IAiSpreadsheetPasteEdit,
  type IAiSpreadsheetRegion,
  type IAiSpreadsheetRegionOverrideReview,
  type IAiSpreadsheetSheetResponse,
} from "@/payroll/ai-script/types";
import type { SpreadsheetRegionViewStates } from "./spreadsheet-region-view";
import { suggestedValueCellRenderer } from "./suggested-value-cell";

export const CUSTOM_CELL_RENDERERS = [suggestedValueCellRenderer] as const;
export const EMPTY_SPREADSHEET_REGIONS: IAiSpreadsheetRegion[] = [];
export const EMPTY_REGION_OVERRIDE_REVIEWS: IAiSpreadsheetRegionOverrideReview[] =
  [];
export const EMPTY_REGION_VIEW_STATES: SpreadsheetRegionViewStates = {};

export const SPREADSHEET_ROW_MARKER_WIDTH = 36;

export const findRegionHeaderForRecord = (
  regions: IAiSpreadsheetRegion[],
  record: Pick<IAiSpreadsheetCell, "row" | "col">,
) =>
  regions.find(
    (region) =>
      region.validation.valid &&
      record.row === region.header_row &&
      record.col >= region.start_col &&
      record.col <= region.end_col,
  );

const VALID_VALUE_TYPES = new Set<string>(
  Object.values(AI_SPREADSHEET_VALUE_TYPE),
);
export const asValueType = (
  value: string | undefined,
): AiSpreadsheetValueType | undefined =>
  value != null && VALID_VALUE_TYPES.has(value)
    ? (value as AiSpreadsheetValueType)
    : undefined;

export const buildHistoryCellEdits = (
  sheetData: IAiSpreadsheetSheetResponse | undefined,
  edits: IAiSpreadsheetPasteEdit[],
) =>
  edits.map((edit) => {
    const prior = findSheetResponseCell(sheetData, edit.cell_id);
    return {
      cellId: edit.cell_id,
      priorRawInput: prior?.raw_input ?? "",
      nextRawInput: edit.raw_input,
      priorKind: getCellKind(prior),
      nextKind: edit.kind ?? getRawInputKind(edit.raw_input),
      priorValueType: asValueType(prior?.value_type ?? undefined),
      nextValueType: edit.value_type,
    };
  });
